import React from "react";
const orderdetails =()=>{
    return(
<div>
    fg
</div>
    )
}
export default orderdetails;